module.exports = __webpack_public_path__ + "static/media/RP-B_S_Jacquard_Meda_Ind.Blue_Peri.9cfeb6f5.png";